/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Cell, DateRange, DateRangeField, Grid, HFlow, Radio, Text, VFlow } from 'bold-ui'
import { PageLoading } from 'components/loading'
import moment from 'moment'
import React, { ReactElement, useEffect, useState } from 'react'

export interface BiTableWrapperProps {
  loading: boolean
  noData: boolean
  children: ReactElement
  handleRangeSelect: (dateRange: DateRange) => void
}

export function BiTableWrapper(props: BiTableWrapperProps) {
  const { loading, noData, children, handleRangeSelect } = props
  const [periodoSelecionado, setPeriodoSelecionado] = useState<number>(3)
  const [dateRangeInput, setDateRangeInput] = useState<DateRange>({
    startDate: moment().subtract(3, 'months').toDate(),
    endDate: new Date(),
  })
  const [dateRangeError, setDateRangeError] = useState<string>('')

  const [ranges] = useState<{ [key: number]: Date }>({
    0: new Date(),
    3: moment().subtract(3, 'months').toDate(),
    6: moment().subtract(6, 'months').toDate(),
    12: moment().subtract(12, 'months').toDate(),
  })

  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.currentTarget.value)
    setDateRangeError('')

    if (value !== 0) {
      const range = { startDate: ranges[value], endDate: ranges[0] }
      setDateRangeInput(range)
      handleRangeSelect(range)
    } else if (dateRangeInput?.startDate && dateRangeInput?.endDate) {
      handleDateRangeChange(dateRangeInput)
    }
    setPeriodoSelecionado(value)
  }

  const handleDateRangeChange = (range: DateRange) => {
    if (range.startDate && range.endDate) {
      const tempStartDate = new Date(range.startDate)
      tempStartDate.setFullYear(range.startDate.getFullYear() + 2)
      if (tempStartDate.getTime() < range.endDate.getTime()) {
        setDateRangeError('O Período não deve ser superior à 2 anos (24 meses), selecione outro período')
      } else {
        setDateRangeError('')
        handleRangeSelect(range)
      }
    } else {
      setDateRangeError('')
    }
    setDateRangeInput(range)
  }

  useEffect(() => {
    handleRangeSelect({
      startDate: moment().subtract(3, 'months').toDate(),
      endDate: new Date(),
    })
  }, [handleRangeSelect])

  return (
    <VFlow>
      <Text variant='h5'>Período</Text>
      <Grid wrap>
        <Cell sm={6} xs={12}>
          <Radio
            name='periodo'
            label='Últimos 3 meses'
            value={3}
            checked={3 === periodoSelecionado}
            onChange={handleOnChange}
          />
        </Cell>
        <Cell sm={6} xs={12}>
          <Radio
            name='periodo'
            label='Últimos 12 meses'
            value={12}
            checked={12 === periodoSelecionado}
            onChange={handleOnChange}
          />
        </Cell>
        <Cell sm={6} xs={12}>
          <Radio
            name='periodo'
            label='Últimos 6 meses'
            value={6}
            checked={6 === periodoSelecionado}
            onChange={handleOnChange}
          />
        </Cell>
        <Cell sm={6} xs={12}>
          <HFlow>
            <Radio
              name='periodo'
              label='Outro'
              value={0}
              checked={0 === periodoSelecionado}
              onChange={handleOnChange}
            />
            <DateRangeField
              clearable={true}
              error={dateRangeError}
              name='outro'
              onChange={handleDateRangeChange}
              value={dateRangeInput}
              disabled={periodoSelecionado !== 0}
              maxDate={new Date()}
              style={{ maxWidth: '400px' }}
            />
          </HFlow>
        </Cell>
      </Grid>
      {loading ? (
        <div
          css={css`
            position: absolute;
            left: 50vw;
            top: 60vh;
          `}
        >
          <PageLoading message='Carregando' />
        </div>
      ) : noData ? (
        <Text>Nenhum dado para o período</Text>
      ) : (
        children
      )}
    </VFlow>
  )
}
